export function isNotSpacesOnly(value) {
    return value && value.trim().length > 0;
}
